import React from "react";
import Image from "../Image/Image";
import { translatePhrase } from "../../utils/functions";
import { IEmptyPlaceholderProps } from "../../models";

enum imageDimensionsEnum {
	"xs" = "60px",
	"sm" = "80px",
	"md" = "100px"
}

const EmptyPlaceholder: React.FC<IEmptyPlaceholderProps> = (props: IEmptyPlaceholderProps) => {
	const imageDimensions: string = props.size === "lg" ? "120px" : imageDimensionsEnum[props.size];
	const transformPhrase = (phrase: string) => {
		if (props.transformPhrase && typeof props.transformPhrase === "function" && props.UiLanguage) {
			return props.transformPhrase(phrase, props.UiLanguage, {});
		} else {
			return translatePhrase(phrase) || phrase;
		}
	};

	return (
		<React.Fragment>
			<div className={`w-100 ${props.className || ""}`} hidden={!!props.hidden}>
				<div
					className={`d-flex justify-content-center align-items-center py-5 ${
						props.size === "xs" ? "placeholder-cont-xs" : "placeholder-cont-sm"
					}`}
				>
					<div className="text-center inner-page-placeholder-container">
						<EmptyPlaceholderIcon
							color={props.RedIcon ? "#f71336" : ""}
							width={imageDimensions}
							height={imageDimensions}
							className={props.imgClass || ""}
						/>

						<h3 className={`${props.RedIcon ? "text-error" : "empty-placeholder-text"} mt-2 text-${props.size}`}>
							{props.message ? <div dangerouslySetInnerHTML={{ __html: props.message }} /> : transformPhrase("noDataFound")}
						</h3>
						<br />
						{props.children}
					</div>
				</div>
			</div>
			<style>{`
            .text-xs{
                font-size: 18px;
            }
        `}</style>
		</React.Fragment>
	);
};
EmptyPlaceholder.displayName = "EmptyPlaceholder";
export default EmptyPlaceholder;

const EmptyPlaceholderIcon = ({ height, width, className, color }: any) => (
	<svg className={className ?? ""} xmlns="http://www.w3.org/2000/svg" width={width ?? "89.994"} height={height ?? "80"} viewBox="0 0 89.994 80">
		<g id="Group_14713" data-name="Group 14713" transform="translate(10827 20464)">
			<path
				id="Path_12115"
				data-name="Path 12115"
				d="M67.524,30.5a8.305,8.305,0,0,1,7.167,4.133l36.72,63.439a8.281,8.281,0,0,1-7.167,12.429H30.8a8.281,8.281,0,0,1-7.167-12.429l36.72-63.439A8.305,8.305,0,0,1,67.524,30.5Zm36.72,76.8a5.075,5.075,0,0,0,4.393-7.618L71.917,36.238a5.075,5.075,0,0,0-8.786,0L26.412,99.677A5.075,5.075,0,0,0,30.8,107.3Z"
				transform="translate(-10849.527 -20494.5)"
				fill={color ?? "#8392a5"}
			/>
			<path
				id="Line_266"
				data-name="Line 266"
				d="M.1,25.079a1.6,1.6,0,0,1-1.6-1.6V.1A1.6,1.6,0,1,1,1.706.1V23.476A1.6,1.6,0,0,1,.1,25.079Z"
				transform="translate(-10781.691 -20440.797)"
				fill={color ?? "#8392a5"}
			/>
			<circle
				id="Ellipse_631"
				data-name="Ellipse 631"
				cx="3.339"
				cy="3.339"
				r="3.339"
				transform="translate(-10785.328 -20409.975)"
				fill={color ?? "#8392a5"}
			/>
		</g>
	</svg>
);
